import React from "react"
import {useLocal} from "../AppContext"
import style from "./SmallScreenLook.css"

export const SmallScreenLook = () => {
    const local = useLocal()

    return <div className={style.load}>
        <div>{local.__("aixFOAM 3D-Raumplaner")}</div>
        <div dangerouslySetInnerHTML={{__html: local.__("Die Fensterauflösung ist für die Darstellung und Bedinnung hat keine ausreichen Größe.")}}/>
        <div>{local.__("Die Mindestauflösung: 1024px x 640px")}</div>
    </div>
}
